
const hasNoApplicants = (shift) => {
  return (shift.current_applicants_pending_user_ids?.length == 0 &&
        shift.current_applicants_denied_user_ids?.length == 0 && 
        shift.current_applicants_approved_user_ids?.length == 0 && 
        shift.current_applicants_nominated_user_ids?.length == 0) 
}

const getShiftRecordRows = (shifts, stateFilters, allUsers) => {

  const totalRows = [];

  const shouldInclude = (state) =>
    !stateFilters || stateFilters.length === 0 || stateFilters.includes(state);

  const createCoverer = (applicantId, userId, status) => ({
    id: 0,
    first_name: '',
    last_name: status,
    applicantStatus: status,
    profile_image: {},
    user_id: userId,
    applicantId
  });

  const createCovererObjectForShiftApplicants = (shift, userIds, applicantIds, status, filterKey) => {
    applicantIds.forEach((applicantId, index) => {
      const userId = userIds[index];
      const copyRow = { ...shift };
      copyRow.coverer = createCoverer(applicantId, userId, status);
      if (shouldInclude(filterKey)) totalRows.push(copyRow);
    });
  };

  shifts?.forEach(shift => {
    if (shift.cover_mode === 'default') {
      if (shift.child_card == false && shift.name === 'shift' ) {
        totalRows.push(shift);
        return;
      }
    }else if (shift.cover_mode === 'multi_applicants_picked_by_manager') {
      const {
        current_applicants_pending_user_ids: pendingUserIds = [],
        current_applicants_pending_ids: pendingApplicantIds = [],
        current_applicants_denied_user_ids: deniedUserIds = [],
        current_applicants_denied_ids: deniedApplicantIds = [],
        current_applicants_approved_user_ids: approvedUserIds = [],
        current_applicants_approved_ids: approvedApplicantIds = [],
        name,
      } = shift;

      if (hasNoApplicants(shift) === true && shouldInclude('posted')) {
        totalRows.push(shift);
      }else if ( name === 'shift' || ((name === 'open_shift' || name === 'shift_vto') && shift.child_card === false) ){
        if(  approvedUserIds.length > 0 && shouldInclude('approved') ){ createCovererObjectForShiftApplicants(shift, approvedUserIds, approvedApplicantIds, '#a', 'approved'); }
        if (pendingUserIds.length > 0 && shouldInclude('pending') ) { createCovererObjectForShiftApplicants(shift, pendingUserIds, pendingApplicantIds, '#p', 'pending'); }
        if (deniedUserIds.length > 0 && shouldInclude('rejected') ) { createCovererObjectForShiftApplicants(shift, deniedUserIds, deniedApplicantIds, '#d', 'rejected'); }
      }
    }

  });

  return totalRows;
};

const getAllApplicantIDs = (shift) => {
  let array = shift.current_applicants_approved_ids.concat(
    shift.current_applicants_denied_ids,
    shift.current_applicants_pending_ids,
    shift.current_applicants_nominated_ids
  );
  return array;
}

const getApplicantIDsForShifts = (shifts) => {
  let array = [];
    shifts.forEach( (shift) => {
      array = array.concat(getAllApplicantIDs(shift));
  });
  const uniqueSet = new Set(array);
  const result = Array.from(uniqueSet);
  return result;
}

export default {
  getShiftRecordRows,
  getApplicantIDsForShifts,
};